import { KnowledgeArchiveCard } from '@/components/features/mindspace/cards/KnowledgeArchiveCard';
import { PracticeArenaCard } from '@/components/features/mindspace/cards/PracticeArenaCard';
import { QuickBytesCard } from '@/components/features/mindspace/quick-bytes/QuickBytesCard';
import { MindspaceToday } from '@/components/features/mindspace/hub/MindspaceToday';
import { MindspaceSpaces } from '@/components/features/mindspace/hub/MindspaceSpaces';
import { useMediaQuery } from '@/hooks/ui/useMediaQuery';

export function MindspacePage() {
  // Below `sm` the page is built for the day, not as a dashboard: what is
  // due today, then the three spaces as a list. Mounted per branch, so a
  // phone neither runs the three card animations nor fetches for them.
  const phone = useMediaQuery('(max-width: 639.98px)');

  if (phone) {
    return (
      <div className='h-full overflow-y-auto'>
        <div className='mx-auto flex max-w-xl flex-col gap-6 px-4 pb-8 pt-6'>
          <header>
            <h1 className='text-3xl font-bold text-foreground'>Mindspace</h1>
            <p className='mt-1 text-muted-foreground'>
              Review what you&apos;ve learned, a little every day.
            </p>
          </header>
          <MindspaceToday />
          <MindspaceSpaces />
        </div>
      </div>
    );
  }

  return (
    <div className='mx-auto flex h-full max-w-7xl flex-col px-4 py-8 sm:px-6 lg:px-8'>
      {/* Header */}
      <div className='mb-6 flex-shrink-0'>
        <h1 className='mb-2 text-3xl font-bold text-foreground'>Mindspace</h1>
        <p className='text-muted-foreground'>Your personal knowledge hub</p>
      </div>

      {/* Dashboard Grid - fills remaining height. At two columns the third
          card spans both, rather than sitting alone beside an empty cell. */}
      <div className='grid min-h-0 flex-1 grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 [&>*:last-child]:md:col-span-2 [&>*:last-child]:lg:col-span-1'>
        <KnowledgeArchiveCard />
        <PracticeArenaCard />
        <QuickBytesCard />
      </div>
    </div>
  );
}
